import { render, staticRenderFns } from "./PreviewFramedImageElement.vue?vue&type=template&id=3f2d92a9&"
import script from "./PreviewFramedImageElement.vue?vue&type=script&lang=js&"
export * from "./PreviewFramedImageElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports